(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["open-positions"]) return;
  try {
    
  
  
  
  // function whenDomReady(fn) {
  //   // see if DOM is already available
  //   if (document.readyState === "complete" || document.readyState === "interactive") {
  //       // call on next available tick
  //       setTimeout(fn, 1);
  //   } else {
  //       document.addEventListener("DOMContentLoaded", fn);
  //   }
  // }

  // function loadJobs() {
  //       return `<script type="text/javascript" src="https://app.jazz.co/widgets/basic/create/mts" charset="utf-8"></script>`;
  //   for go-live
  //   const request = "https://jazzhr.mtsproservices.com/mts_jobs.php";
    
  //   fetch(request, {
  //       method: "GET"
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data);
  //       if (data.length > 0) {
  //         for (const job of data) {
  //           const listItem = renderJob(job);
  //           const list = selectLocationList(job);
  //           list.appendChild(listItem);
  //         }  
  //       }
  //       else {
  //         // display "check back later" message
  //         showNoJobsMessage();
  //       }
  //     })
  //     .catch(function(e) {
  //       console.log(e);
  //       showNoJobsMessage();
  //     });
  // }

  // function showNoJobsMessage() {
  //   let noJobsContainer = document.getElementById("no-open-positions-container");
  //   noJobsContainer.innerHTML = "<p>We don't have any open positions right now. Please check back again later.</p>";
  // }

  // function renderJob(job) {
  //   const listItem = document.createElement("li");
  //   listItem.className = "resumator-job-link flex items-center justify-center w-16 w-auto p-1 mt-2 font-semibold text-center text-white bg-gray-100 border rounded-md hover:bg-gray-200 text-blue border-blue";
  //   listItem.innerHTML = `<strong class='mr-10'>${job.title}</strong>`;
  //   listItem.innerHTML += `<a href='https://mts.applytojob.com/apply/${job.board_code}'>Apply</a>`;

  //   return `<script type="text/javascript" src="https://app.jazz.co/widgets/basic/create/mts" charset="utf-8"></script>`;
  // }

  // function selectLocationList(job) {
  //   let jobLocation = "";
    
  //   job.city.split(" ").forEach((x) => {
  //     jobLocation += x + "-";
  //   });
  //   jobLocation += job.state;
    
  //   let locationDomId = jobLocation.toLowerCase();

  //   let locationList = null;
  //   let locationElement = document.getElementById(locationDomId);
  //   if (!locationElement) {
  //     locationElement = document.createElement("li");
  //     locationElement.id = locationDomId;
  //     locationElement.innerText = job.city + ", " + job.state;
  //     locationList = document.createElement("ul");
  //     locationList.id = `${locationDomId}-list`;

  //     locationElement.appendChild(locationList);
  //     document.getElementById("locations-container")
  //       .appendChild(locationElement);
  //   }
  //   else {
  //     locationList = locationElement.getElementsByTagName('ul')[0];
  //   }
    
  //   return locationList;
  // }

  whenDomReady(loadJobs);




  } catch(e) { console.error(e); }
})();
})();
